import { Layout, Menu } from 'antd';
import { getRoutes } from '../../../../routes';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { MainContext } from '../../../../context/MainContext';
import { useContext, useEffect, useState } from 'react';
import PropTypes from '../../../../utils/propTypes';
import { useSelector } from 'react-redux';
import { Providers } from '../../../../constants/providers';

const { Sider: AntdSider } = Layout;

const { menu } = styles;

function generatePaths(pathname, project) {
  let parts = pathname.split('/');
  parts[3] = ':id';
  parts.pop();
  let result = parts.map((_, index) => {
    return parts.slice(0, index + 1).join('/');
  });
  result = result.filter((path) => path.length > 0 && path !== '/');
  return result;
}

const Sider = ({ collapsed, onCollapse }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useContext(MainContext);
  const { pathname } = useLocation();
  const mainRoutes = getRoutes(intl);
  const [openKeys, setOpenKeys] = useState([]);
  const { me } = useSelector(({ auth }) => auth);

  const filterRoutes = (route) => {
    if (!route.path || route.path === '*' || route.path === 'nc') {
      return false;
    }

    return route.handle?.showInSider !== false;
  };

  const generateMenuItems = (routes, level = 1) => {
    return routes
      .filter(filterRoutes) // Filtrar PRIMERO
      .map((route, i) => {
        let custom;
        if (route.path === 'ocr') {
          const customChildren = [...route.children];
          if (
            project?.concrete_providers.some(
              (cp) => cp.provider !== Providers.CEMEX,
            )
          ) {
            custom = customChildren.filter(
              (child) => child.path !== 'cemex-tracking',
            );
          }
        }

        if (route.path === 'quality') {
          let customChildren = [...route.children];
          customChildren = customChildren.filter(
            (child) => child.path !== 'ehe' && child.path !== 'ce',
          );
          customChildren.splice(project?.id_normative === 1 ? 3 : 2, 1);
          custom = customChildren;
        }

        /*         if (route.path === 'ce' || route.path === 'ehe') {
          const customChildren = [...route.children];
          custom = customChildren.slice(0, 4);
        } */

        if (route.path === 'project/:id') {
          const customChildren = [...route.children]
            .filter((child) => child.path !== 'edit')
            .filter(
              (child) => !(child.path === 'options' && me?.role !== 'ADMIN'),
            )
            .map((child) => {
              if (child.path === 'quality' && me?.role === 'USER MADUREZ') {
                return {
                  ...child,
                  disabled: true,
                };
              }

              if (child.path === 'strength' && me?.role === 'USER CALIDAD') {
                return {
                  ...child,
                  disabled: true,
                };
              }
              return child;
            });
          custom = customChildren;
        }

        // Rutas que no deberían mostrar children en el sider
        const shouldHideChildren =
          route.path === 'templates' ||
          route.path === 'prm' ||
          route.path === 'scannedDocumentsRC' ||
          route.path === 'scannedDocumentsPC';

        return {
          path: route.path,
          key: route.handle?.fullnavigation,
          label: route.handle?.crumb?.toUpperCase(),
          icon: route.handle?.icon,
          disabled: route.disabled,
          children: shouldHideChildren
            ? undefined
            : custom
            ? generateMenuItems(custom, level + 1)
            : route.children && route.children.length > 1
            ? generateMenuItems(route.children, level + 1)
            : undefined,
        };
      });
  };

  const menuItems = generateMenuItems(
    [mainRoutes[2]?.children?.[3]].filter(Boolean),
  );

  useEffect(() => {
    if (project) {
      setOpenKeys(generatePaths(pathname, project));
    }
  }, [pathname, project]);
  return (
    <AntdSider
      collapsible
      collapsed={collapsed}
      collapsedWidth={0}
      onCollapse={(value) => onCollapse(value)}
      trigger={null}
      width="20vw"
    >
      {!collapsed && (
        <Menu
          defaultSelectedKeys={['1']}
          mode="inline"
          items={menuItems}
          className={menu}
          selectable
          openKeys={openKeys}
          onOpenChange={(keys) => setOpenKeys(keys)}
          selectedKeys={[pathname.replace(/\/\d+\//, '/:id/')]}
          onClick={({ keyPath }) => {
            const keysStr = keyPath[0].replace(':id', project.id_project);
            navigate(keysStr);
          }}
        />
      )}
    </AntdSider>
  );
};

Sider.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapse: PropTypes.func.isRequired,
};

export default Sider;
